import {omit} from "lodash";
import {ISeller, ISellerJson} from "./seller.interface";
import {statusTypes} from "./enums";



const reorderSellerObject = (seller: ISeller) => {
    const desiredOrder = ["seller_id", "seller_type", "is_confidential", "domain", "name"];
    const newObj: ISeller = {domain: "", is_confidential: 0, name: "", seller_id: "", seller_type: ""};
    desiredOrder.forEach(key => {
            newObj[key] = seller[key];
    });
    return newObj;
};


export const prepareSellersForOutput = (seller:Partial<ISellerJson>) :ISellerJson=> {
    if (seller && seller.sellers && Array.isArray(seller.sellers)) {
        seller= omit(seller, ['isChanged', 'isValidate','__v','_id','created','updated','isActive','isDeleted','organization']);
        return {
            ...seller,
            sellers: seller.sellers.map((s) => {
               return reorderSellerObject(s);

            }),
        } as ISellerJson;

    }
    return seller as ISellerJson;
};

export const filterCreatedSellers = (seller: ISellerJson) => {
    console.log('seller', seller);
    if (seller && seller.sellers && Array.isArray(seller.sellers)) {
        return {
            ...seller,
            sellers: seller.sellers.filter((s) => s.validation.status.type !== statusTypes.CREATED),
        };
    }
    return seller;

}


export const openSellerTextOnNewTab = async (sellerJson: ISellerJson, withCreatedSellers:boolean) => {
    if (!withCreatedSellers) {
        sellerJson = filterCreatedSellers(sellerJson);
    }
    sellerJson= prepareSellersForOutput(sellerJson);
    sellerJson.sellers.sort((a, b) => Number(a.seller_id) - Number(b.seller_id));
    const url = window.URL.createObjectURL(new Blob([JSON.stringify(sellerJson)], { type: 'application/json' }));
    window.open(url, '_blank');
}
